import { CloseIcon } from "@chakra-ui/icons";
import { HStack, IconButton, Input } from "@chakra-ui/react";
import { useEffect, useState } from "react";

// Hooks
import useClaimsToast from "../../../hooks/useToast";

// Types
import { DataTableColumn } from "../../../utils/types";

interface ColumnFilterDatePickerProps {
	isDisabled: boolean | undefined;
	column: DataTableColumn;
	date: string | undefined;
	handleSearch: (columnId: string, value: string) => void;
}

export default function ColumnFilterDatePicker({
	isDisabled,
	column,
	date,
	handleSearch
}: ColumnFilterDatePickerProps) {
	const [initialDate, setInitialDate] = useState<string | undefined>(date?.split("T")[0]);
	const toast = useClaimsToast();

	// When cleared, also clear the local date
	useEffect(() => {
		if ((!date || date == "") && initialDate != null) {
			setInitialDate(undefined);
		}
	}, [date]);

	const handleDateChange = (newDate: string) => {
		setInitialDate(newDate);
		handleSearch(column.id, newDate);
	};

	const handleOnPasteEvent = async (): Promise<void> => {
		const pastedDate: string = await navigator.clipboard.readText();
		const validDate: Date = new Date(pastedDate);
		if (!isNaN(validDate.getTime())) {
			handleDateChange(validDate.toISOString().split("T")[0]);
		} else {
			toast("Error", "Invalid date", "error");
		}
	};

	return (
		<HStack width="100%">
			<Input
				type="date"
				size="sm"
				placeholder="⌕"
				pl="7px"
				pr={initialDate != null ? "24px" : "10px"}
				css={{
					"&::placeholder": {
						textAlign: "right"
					},
					"&::-webKit-input-placeholder": {
						textAlign: "right"
					}
				}}
				value={initialDate || ""}
				max={new Date().toISOString().split("T")[0]}
				onChange={(event) => handleDateChange(event.target.value)}
				isDisabled={isDisabled}
				disabled={false}
				onPaste={(event) => {
					event.preventDefault();
					handleOnPasteEvent().catch((err) => console.error("Error handling paste event", err));
				}}
			/>

			{!!date && (
				<IconButton
					size="xs"
					p="5px"
					zIndex={5}
					h="20px"
					w="19px"
					minW="15px"
					ml="-33px"
					mr="6px"
					aria-label="sort"
					icon={<CloseIcon fontSize="9px" />}
					isDisabled={isDisabled}
					onClick={() => {
						handleSearch(column.id, "");
					}}
				/>
			)}
		</HStack>
	);
}
